import { Injectable, signal, effect } from '@angular/core';

export type Theme = 'light' | 'dark';
const STORAGE_KEY = 'mockingbird.theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly systemPrefersDark =
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

  readonly theme = signal<Theme>(this.readInitial());

  constructor() {
    effect(() => {
      const value = this.theme();
      document.documentElement.setAttribute('data-theme', value);
      localStorage.setItem(STORAGE_KEY, value);
    });
  }

  toggle(): void {
    this.theme.set(this.theme() === 'dark' ? 'light' : 'dark');
  }

  private readInitial(): Theme {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') {
      return stored;
    }
    return this.systemPrefersDark ? 'dark' : 'light';
  }
}
